module.exports = __webpack_public_path__ + "img/stylus-highlighter.aed1dc8c.svg";